// Layer 3 of the "no more surprises" defense.
//
// Catches runtime errors that happen OUTSIDE the React render tree
// (event handlers, async/await rejections, click handlers, etc.) —
// the React ErrorBoundary only catches errors thrown during render.
//
// Posts every error to /api/client-error so the main agent can see
// what blew up without making the director read a stack trace.

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const recentlyLogged = new Set(); // crude dedupe so we don't spam the backend

function report(payload) {
  const key = `${payload.kind}|${payload.message?.slice(0, 100)}`;
  if (recentlyLogged.has(key)) return;
  recentlyLogged.add(key);
  setTimeout(() => recentlyLogged.delete(key), 10_000);
  try {
    axios.post(`${BACKEND_URL}/api/client-error`, payload)
      .catch(() => { /* never let logging fail the app */ });
  } catch { /* paranoia */ }
}

window.addEventListener("error", (event) => {
  report({
    kind: "window_error",
    message: String(event.message || ""),
    source: String(event.filename || ""),
    line: event.lineno,
    column: event.colno,
    stack: String(event.error?.stack || ""),
    url: window.location.href,
    user_agent: navigator.userAgent,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  report({
    kind: "unhandled_promise",
    message: String(reason?.message || reason || ""),
    stack: String(reason?.stack || ""),
    url: window.location.href,
    user_agent: navigator.userAgent,
  });
});
